import { render, staticRenderFns } from "./ProductTypeGroupsPage.vue?vue&type=template&id=2549b3a2&scoped=true"
import script from "./ProductTypeGroupsPage.vue?vue&type=script&lang=js"
export * from "./ProductTypeGroupsPage.vue?vue&type=script&lang=js"
import style0 from "./ProductTypeGroupsPage.vue?vue&type=style&index=0&id=2549b3a2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2549b3a2",
  null
  
)

export default component.exports